/* eslint-disable no-undef */
import bitsFetch from '../Childs/bitsFetch'

export const saveIntegConfig = (allintegs, setIntegration, allIntegURL, confTmp, history, id, edit) => {
  const integs = [...allintegs]
  if (edit) {
    integs[id] = { ...allintegs[id], ...confTmp }
    integs.push({ editItegration: true })
    setIntegration([...integs])
    history.push(allIntegURL)
  } else {
    const newInteg = [...integs]
    newInteg.push(confTmp)
    newInteg.push({ newItegration: true })
    setIntegration(newInteg)
    history.push(allIntegURL)
  }
}

export const setGrantTokenResponse = () => {
  const grantTokenResponse = {}
  const authWindowLocation = window.location.href
  const queryParams = authWindowLocation.replace(`${window.opener.location.href}?`, '').split('&')
  if (queryParams) {
    queryParams.forEach(element => {
      const gtKeyValue = element.split('=')
      if (gtKeyValue[1]) {
        // eslint-disable-next-line prefer-destructuring
        grantTokenResponse[gtKeyValue[0]] = gtKeyValue[1]
      }
    })
  }
  localStorage.setItem(`__wcZohoInventory`, JSON.stringify(grantTokenResponse))
  window.close()
}

export const handleAuthorize = (scopes, confTmp, setConf, setError, setisAuthorized, setisLoading, setSnackbar) => {
  if (!confTmp.dataCenter || !confTmp.clientId || !confTmp.clientSecret) {
    setError({
      dataCenter: !confTmp.dataCenter ? 'Data center cann\'t be empty' : '',
      clientId: !confTmp.clientId ? 'Client ID cann\'t be empty' : '',
      clientSecret: !confTmp.clientSecret ? 'Secret key cann\'t be empty' : '',
    })
    return
  }
  setisLoading(true)
  const apiEndpoint = `https://accounts.zoho.${confTmp.dataCenter}/oauth/v2/auth?scope=${scopes}&response_type=code&client_id=${confTmp.clientId}&prompt=Consent&access_type=offline&redirect_uri=${bit_wc_zoho_inventory.api.base}/authoraization`
  const authWindow = window.open(apiEndpoint, 'wcZohoInventory', 'width=400,height=609,toolbar=off')
  const popupURLCheckTimer = setInterval(() => {
    if (authWindow.closed) {
      clearInterval(popupURLCheckTimer)
      let grantTokenResponse = {}
      let isauthRedirectLocation = false
      const bitformsZoho = localStorage.getItem(`__wcZohoInventory`)
      if (bitformsZoho) {
        isauthRedirectLocation = true
        grantTokenResponse = JSON.parse(bitformsZoho)
        localStorage.removeItem(`__wcZohoInventory`)
      }
      if (!grantTokenResponse.code || grantTokenResponse.error || !grantTokenResponse || !isauthRedirectLocation) {
        const errorCause = grantTokenResponse.error ? `Cause: ${grantTokenResponse.error}` : ''
        setSnackbar({ show: true, msg: `Authorization failed ${errorCause}. please try again` })
        setisLoading(false)
      } else {
        const newConf = { ...confTmp }
        newConf.accountServer = grantTokenResponse['accounts-server']
        tokenHelper(grantTokenResponse, newConf, setConf, setisAuthorized, setisLoading, setSnackbar)
      }
    }
  }, 500)
}

const tokenHelper = (grantToken, confTmp, setConf, setisAuthorized, setisLoading, setSnackbar) => {
  const tokenRequestParams = { ...grantToken }
  tokenRequestParams.dataCenter = confTmp.dataCenter
  tokenRequestParams.clientId = confTmp.clientId
  tokenRequestParams.clientSecret = confTmp.clientSecret
  tokenRequestParams.redirectURI = `${bit_wc_zoho_inventory.api.base}/authoraization`
  bitsFetch(tokenRequestParams, `bit_wc_generate_token`)
    .then(result => result)
    .then(result => {
      if (result && result.success) {
        const newConf = { ...confTmp }
        newConf.tokenDetails = result.data
        setConf(newConf)
        setisAuthorized(true)
        setSnackbar({ show: true, msg: 'Authorized Successfully' })
      } else if ((result && result.data && result.data.data) || (!result.success && typeof result.data === 'string')) {
        setSnackbar({ show: true, msg: `Authorization failed Cause:${result.data.data || result.data}. please try again` })
      } else {
        setSnackbar({ show: true, msg: 'Authorization failed. please try again' })
      }
      setisLoading(false)
    })
}

export const addFieldMap = (i, type, confTmp, setConf, uploadFields) => {
  const newConf = { ...confTmp }
  uploadFields ? newConf.upload_field_map[type].splice(i, 0, { formField: '', zohoFormField: '' }) : newConf.field_map[type].splice(i, 0, { formField: '', zohoFormField: '' })

  setConf({ ...newConf })
}

export const delFieldMap = (i, type, confTmp, setConf, uploadFields) => {
  const newConf = { ...confTmp }
  if (uploadFields) {
    if (newConf.upload_field_map[type].length > 1) {
      newConf.upload_field_map[type].splice(i, 1)
    }
  } else if (newConf.field_map[type].length > 1) {
    newConf.field_map[type].splice(i, 1)
  }

  setConf({ ...newConf })
}

export const handleFieldMapping = (val, name, index, type, conftTmp, setConf, uploadFields) => {
  const newConf = { ...conftTmp }
  if (uploadFields) newConf.upload_field_map[type][index][name] = val
  else newConf.field_map[type][index][name] = val

  if (val === 'custom') {
    newConf.field_map[type][index].customValue = ''
  }

  setConf({ ...newConf })
}

export const handleCustomValue = (event, index, type, conftTmp, setConf) => {
  const newConf = { ...conftTmp }

  newConf.field_map[type][index].customValue = event.target.value

  setConf({ ...newConf })
}
